"use strict";
var core_1 = require('@angular/core');
var common_1 = require('@angular/common');
var select_1 = require('./select');
var select_pipes_1 = require('./select-pipes');
var off_click_1 = require('./off-click');
var SelectModule = (function () {
    function SelectModule() {
    }
    SelectModule.decorators = [
        { type: core_1.NgModule, args: [{
                    imports: [common_1.CommonModule],
                    declarations: [select_1.SelectComponent, select_pipes_1.HighlightPipe, off_click_1.OffClickDirective],
                    exports: [select_1.SelectComponent, select_pipes_1.HighlightPipe, off_click_1.OffClickDirective]
                },] },
    ];
    /** @nocollapse */
    SelectModule.ctorParameters = function () { return []; };
    return SelectModule;
}());
exports.SelectModule = SelectModule;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-select/select/select.module.js
// module id = ./node_modules/ng2-select/select/select.module.js
// module chunks = 5